import {Action} from "@ngrx/store";
import {UserLogOut} from "./user.action";

export const LOAD_PURCHASED_DOMAINS: string = '[domainsPortfolio] Load Purchased Domains';
export const PURCHASED_DOMAINS_SUCCESS: string = '[domainsPortfolio] Purchased Domains Success';
export const PURCHASED_DOMAINS_FAIL: string = '[domainsPortfolio] Purchased Domains Fail';
export const RESET_PURCHASED_DOMAINS: string = '[Domains Portfolio] Reset Purchased Domains';

export class LoadPurchasedDomains implements Action {

  readonly type: string = LOAD_PURCHASED_DOMAINS;

  constructor(public payload?: number) {
  }
}

export class PurchasedDomainsSuccess implements Action {

  readonly type: string = PURCHASED_DOMAINS_SUCCESS;

  constructor(public payload: {
    domains: any,
  }) {
  }

}

export class PurchasedDomainsFail implements Action {

  readonly type: string = PURCHASED_DOMAINS_FAIL;

  constructor() {
  }

}

export class ResetPurchasedDomains implements Action {

  readonly type: string = RESET_PURCHASED_DOMAINS;

  constructor() {
  }

}

export type DomainsPortfolioAction = LoadPurchasedDomains | PurchasedDomainsSuccess | PurchasedDomainsFail | ResetPurchasedDomains | UserLogOut;
